export const setMoedasToSelect = (data) =>
  sessionStorage.setItem("moedas", JSON.stringify(data));
export const getMoedasToSelect = () =>
  JSON.parse(sessionStorage.getItem("moedas"));
